export const DATE_FORMAT = 'dd/MM/yyyy';

export const LEAVE_STATUS = {
    NEW: 'new',
    APPROVER: 'approver'
}

export const LEAVE_REQUEST = {
    startDate: '',
    endDate: '',
    reportDate: '',
    contactInVacation: 'Mohamed Noohu',
    mobileNoInVacation: '9942305949',
    emailInVacation: 'mohamed.noohu@gmail.com',
    leaveType: [{
        id: 1,
        desc: 'Annual Leave'
    }],
    ticketStatus: 'Company'
};

export const ROLES = {
    role: 'new'
};


export const LEAVE_TYPE = [
    {
        id: 1,
        label: 'Select Leave Type',
        value: null
    },
    {
        id: 2,
        label: 'Annual Leave',
        value: 'Annual Leave'
    },
    {
        id: 3,
        label: 'Unpaid Leave',
        value: 'Unpaid Leave'
    },
    {
        id: 4,
        label: 'Examination Leave',
        value: 'Examination Leave'
    },
    {
        id: 5,
        label: 'Child Birth Leave (3 Days)',
        value: 'Child Birth Leave (3 Days)'
    },
    {
        id: 6,
        label: 'Hajj Leave (5 Days)',
        value: 'Hajj Leave (5 Days)'
    },
    {
        id: 7,
        label: 'Death Leave (5 Days)',
        value: 'Death Leave (5 Days)'
    },
    {
        id: 8,
        label: 'Marriage Leave (5 Days)',
        value: 'Marriage Leave (5 Days)'
    },
    {
        id: 9,
        label: 'Sick Leave',
        value: 'Sick Leave'
    },
    {
        id: 10,
        label: 'Others (Specify)',
        value: 'Others (Specify)'
    }
];




export const INSTITUTION_LIST = [
    {
        label: 'Institution 1',
        value: 'Institution 1'
    }, 
    {
        label: 'Institution 2',
        value: 'Institution 2'
    }, 
]

export const VACATION_FOR = [
    {
        label: 'For me only',
        value: 'For me only'
    }
]


export const COURSE_LIST = [
    { label: 'Course 1', value: 'Course 1'}, 
    { label: 'Course 2', value: 'Course 2'}, 
 
]

export const YEARS = [
    { label: '2020', value: '2020'}, 
    { label: '2021', value: '2021'}, 
    { label: '2022', value: '2022'}, 
    { label: '2023', value: '2023'}, 
    { label: '2024', value: '2024'}, 
    { label: '2025', value: '2025'}, 
    { label: '2026', value: '2026'}, 
    { label: '2027', value: '2027'}, 
 
]





export const EMPLOYEE_DETAILS = {
    employee: [{
        name: 'Mohamed Noohu',
        age: 35,
        empGender: 'Male',
        fromDate: '',
        toDate: '',
        ticketClass: 'One Way',
        fromRoute: 'coimbatore',
        toRoute: 'sanfransisco',
        location: 'In KSA'
    }],

    depedent: [
        {
            id: 1,
            name: 'Shaik Nuzla',
            relation: 'Spouse',
            age: 30,
            gender: 'Female',
            fromDate: '',
            toDate: '',
            ticketClass: 'One Way',
            fromRoute: 'coimbatore',
            toRoute: '',
            location: 'In KSA'
        },
        {
            id: 2,
            name: 'Syed',
            relation: 'Child',
            age: 12,
            gender: 'Male',
            fromDate: '',
            toDate: '',
            ticketClass: 'Round Trip',
            fromRoute: '',
            toRoute: 'coimbatore',
            location: 'In KSA'
        }
    ]
};

export const ACTION_DETAILS = [
    {
        actionNo: 1,
        createdBy: 'Noohu',
        actionName: 'VR',
        deptName: 'IMM',
        respBy: 'Syed',
        targetDate: '03/03/2020',
        status: ''
    }
];

export const ACTION_LIST = [
    {
        value: "VR",
        label: 'Visa Request'
    },
    {
        value: "TKT",
        label: 'Ticket Booking'
    },
    {
        value: 'HB',
        label: 'Hotel Booking'
    },
    {
        value: 'TEST',
        label: 'Test Action'
    }
];


export const DEPT_LIST = [
    {
        value: "HR",
        label: 'Human Resource'
    },
    {
        value: "SOFT",
        label: 'Software Department'
    },
    {
        value: 'NET',
        label: 'Networking'
    },
    {
        value: 'IMM',
        label: 'Immigration'
    }
];